export default {
  addresses: [],
  address: {}
}
